module.exports = __webpack_public_path__ + "img/9791195500604.1a902d0d.jpg";